/**
 * Parse a ratio represented as a string into a float
 */
export function parseRatio(str: string) {
    const [a, b] = `${str}`.trim().split(':');
    return (parseFloat(a) || 1) / (parseFloat(b) || 1);
}

/**
 * Find the radius of the largest circle that can be inscribed in a sector
 * @param theta An angle, in radians, of a sector of a unit circle
 * @see https://math.stackexchange.com/questions/1662616
 */
export function sectorRadius(theta: number) {
    return (Math.sin(theta / 2)) / (1 + Math.sin(theta / 2));
}
